<script setup>
import {computed, onMounted, ref} from "vue";
import axiosApi from "@/utils/axiosApi";
import {useRoute} from "vue-router";
import {couponConf} from "@/utils/config";
import LoginComponents from "@/components/login/LoginComponents.vue";
import XmLogin from "@/components/login/xmLogin.vue";
import store from "@/store";
import SendSmsComponents from "@/components/login/SendSmsComponents.vue";
import {ElMessage} from "element-plus";
import RealName from "@/components/login/RealName.vue";
import router from "@/router";

const coupon = ref({})
const showLogin = ref(false)
const route = useRoute()
const type = computed(() => couponConf['hibake-scal'])
const account = computed(() => store.state.account)
const mobile = ref("")
const number = ref(1)
const maxNumber = computed(() => {
  if (Object.keys(account.value).length < 1 || parseFloat(account.value.balance_miles) < parseFloat(coupon.value.score_data[type.value.login].total)) return 1
  return Math.floor(parseFloat(account.value.balance_miles) / parseFloat(coupon.value.score_data[type.value.login].total))
})
const showProduct = ref(false)
const loading = ref(false)
const sendSms = ref(false)
const realname = ref(false)
onMounted(() => {
  store.dispatch("getAccounts")
  store.commit("getOrderFrom")
  getCoupon()
  setTimeout(() => {
    if (route.query.pay) checkLogin()
  }, 500)
})

const getCoupon = () => {
  new axiosApi({
    encode: 'site',
    method: "coupon/cat_coupon_detail",
    body: {
      cid: route.params.id
    }
  }).send(res => {
    if (res.message.code === "000") {
      res.data.detail = res.data.detail.filter(v => v.key.length && v.value.length)
      coupon.value = res.data
      let details = {}
      coupon.value.detail.forEach(v => {
        // if (v.key === "banner") v.value = JSON.parse(v.value)
        details[v.key] = v.value
      })
      if (!details.banner) {
        details.banner = [coupon.value.img]
      }
      coupon.value.detail = details
      // console.log(coupon)
      document.title = coupon.value.name

    }
  })
}
const reloadLogin = () => {
  showLogin.value = false
  if (Object.keys(account.value).length) {
    showProduct.value = true
  }
}
const checkLogin = () => {
  if (Object.keys(account.value).length) {
    showProduct.value = true
  } else {
    showLogin.value = true
  }
}
const order_from = computed(() => store.state.orderFrom)
const payment = () => {
  if (!/^1[3-9]\d{9}$/.test(mobile.value)) {
    return ElMessage.error("手机号格式错误")
  }

  if (type.value.login === 'scal' && !sendSms.value) return sendSms.value = true
  sendSms.value = false
  loading.value = true
  let pay_params = JSON.stringify(type.value.login === 'xm_air' ? {
    access_token: account.value.access_token,
    user_id: account.value.user_id
  } : {cust_id: account.value.cust_id})
  new axiosApi({
    method: "coupon/pay",
    encode: "site",
    body: {
      coupon_id: coupon.value.id,
      uid: account.value.uid,
      pay_type: type.value.login,
      pay_params,
      number: number.value,
      auto_coupon: "1",
      mobile: mobile.value,
      order_from: order_from.value
    }
  }).send(res => {
    loading.value = false
    if (res.message.code !== "000" && res.message.code !== "7041") {
      return ElMessage.error(res.message.content)
    } else if (res.message.code === "7041") {
      realname.value = true
      return
    }
    if (type.value.login !== 'xm_air')
      router.replace({name: 'success', params: {order: res.data.ordersn}})
    else window.location.replace(res.data.url)
  }, () => {
    loading.value = false
    ElMessage.error("兑换失败")
  })
}
</script>

<template>
  <!--  {{ type }}-->
  <el-scrollbar style="height: calc(100vh - 60px)" v-if="Object.keys(coupon).length">
    <el-image :src="coupon?.detail?.banner" style="width: 100%"/>
    <div class="coupon-detail">
      <h3>{{ coupon?.name }}</h3>
      <div class="coupon-detail-price">
        <b>{{ coupon?.score_data?.[type.login]?.total }}{{ coupon?.score_data?.[type.login]?.unit }}</b>
        <el-text type="info">￥{{ coupon?.face_value }}</el-text>
      </div>
    </div>
    <div v-html="coupon?.remark"></div>
  </el-scrollbar>
  <div class="coupon-detail-btn" v-if="Object.keys(coupon).length">
    <div class="money">
      <el-text type="warning" style="font-size: 1.55rem">{{ coupon?.score_data?.[type.login]?.total }}</el-text>
      <el-text type="info">{{ coupon?.score_data?.[type.login]?.unit }}</el-text>
    </div>
    <el-button @click="checkLogin" round>立即兑换</el-button>
  </div>
  <el-empty v-if="Object.keys(coupon).length < 1"/>
  <login-components :show-login="showLogin" v-if="showLogin && type.login === 'scal'" @login="reloadLogin"/>
  <xm-login :show-login="showLogin" v-if="showLogin && type.login === 'xm_air'" @login="reloadLogin"/>
  <el-drawer v-model="showProduct" direction="btt" class="product-drawer" size="520" :show-close="false">
    <template #header>
      <div class="product-pay-header">
        <el-image :src="coupon.img"/>
        <div style="line-height: 1.7">
          <h4>{{ coupon.name }}</h4>
          <div class="money">
            <el-text type="warning" style="font-size: 1.55rem">{{ coupon?.score_data?.[type.login]?.total }}</el-text>
            <el-text type="info">{{ coupon?.score_data?.[type.login]?.unit }}</el-text>
          </div>
        </div>
      </div>

    </template>
    <div class="tips">
      <el-text type="info">
        兑换成功后，兑换码将以短信的形式发放至下方
        <el-text type="danger">填写的手机号</el-text>
        ,因手机号填写错误造成的损失由会员本人承担。
      </el-text>
    </div>
    <el-card>
      <div class="product-inputs">
        <div class="product-inputs-item">
          收货手机号
        </div>
        <div class="product-inputs-input">
          <el-input v-model="mobile" placeholder="请填写收货手机号"/>
        </div>
      </div>
    </el-card>
    <el-card>
      <div class="product-inputs">
        <div class="product-inputs-item">
          兑换数量
        </div>
        <div class="product-inputs-input">
          <el-input-number v-model="number" :min="1" :max="maxNumber"/>
        </div>
      </div>
    </el-card>
    <el-card>
      <div class="product-inputs">
        <div class="product-inputs-item">
          可用{{ coupon?.score_data?.[type.login]?.unit }}
        </div>
        <div class="product-inputs-input">
          <!--          <el-input-number v-model="number" :min="1" :max="maxNumber"/>-->
          {{ account?.balance_miles }}
        </div>
      </div>
      <div class="product-inputs">
        <div class="product-inputs-item">
          支付{{ coupon?.score_data?.[type.login]?.unit }}
        </div>
        <div class="product-inputs-input">
          {{ parseFloat(coupon?.score_data?.[type.login]?.total) * number }}
        </div>
      </div>
    </el-card>
    <div class="product-pay">
      <el-button @click="payment" round size="large"
                 :disabled="Object.keys(account).length < 1 || parseFloat(account.balance_miles) < parseFloat(coupon?.score_data?.[type.login]?.total) * number"
                 :loading="loading">立即兑换
      </el-button>
    </div>
  </el-drawer>
  <send-sms-components v-if="sendSms" :show="sendSms" @sends="payment" :login-account="account"/>
  <real-name :dialog="realname" v-if="realname"/>
</template>

<style scoped lang="less">
.coupon-detail {
  box-sizing: border-box;
  padding: 15px;
  line-height: 1.7;

  .el-text {
    //删除线
    text-decoration: line-through;
  }
}

.coupon-detail-btn {
  height: 60px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 15px;
  justify-content: right;

  .money {
    margin-right: 10px;
  }

  .el-button {
    width: 120px;
    background: linear-gradient(to bottom, #c8b29f, #a67a55);
    color: #ffffff;
  }
}

.product-drawer {
  .product-pay-header {
    display: flex;
    //align-items: center;
    .el-image {
      width: 100px;
      flex-basis: 100px;
      margin-right: 10px;
    }
  }

  .tips {
    margin-top: -15px;
    margin-bottom: 15px;
  }

  .el-card {
    --el-card-border-radius: 12px;
    margin-bottom: 15px;

    .product-inputs {
      display: flex;
      align-items: center;
      justify-content: space-between;

      & + .product-inputs {
        margin-top: 10px;
        padding-top: 10px;
        border-top: var(--el-border);
      }

      .product-inputs-item {
        width: 120px;
        flex-basis: 120px;
      }

      .product-inputs-input {
        width: calc(100% - 120px);
        text-align: right;
      }
    }
  }

  .product-pay {
    .el-button {
      width: 100%;
      background: linear-gradient(to bottom, #c8b29f, #a67a55);
      color: #ffffff;
    }
  }
}
</style>
